export default __webpack_public_path__ + "static/media/sari (5).7d298588.jpeg";